<template>
    <div class="basic-product">
        <CRow class="mb-4 basic-category-row">
            <CCol class="col-4 mb-2">
              <label class="required">SKU</label>
              <div class="dropdown_wrapper">
                <v-select
                  :disabled="step_completed==3"
                  @input="SetProductDetail"
                  v-model="form.basic.sku"
                  :options="skus"
                  :name="`product_sku`"
                  :selectable="checkSKU"
                  placeholder="Select from files..."
                  v-validate="'required'"
                  :key="`sku-id`"
                    >
                </v-select>
                  </div>
                  <div v-if="errors && errors.first(`product_sku`)" class="error_msg">
                    {{ errors.first(`product_sku`) }}
                  </div>
            </CCol>
            <CCol class="col-4 mb-2">
              <label class="required">Product Type</label>
              <div class="dropdown_wrapper">
                <v-select  v-model="form.basic.product_type"
                           :options="product_types"
                           name="product_type"
                           placeholder="Select product type"
                           v-validate="'required'"
               >
              </v-select>

              </div>
              <div v-if="errors && errors.first('product_type')" class="error_msg">
                {{ errors.first('product_type') }}
              </div>
            </CCol>
            <CCol class="col-4 mb-2">
                <label class="required">URL Slug</label>
                <b-input-group prepend="#/products/">
                    <b-form-input
                        label="URL Slug"
                        type="text"
                        name="slug"
                        v-validate="'required|alpha_dash'"
                        v-model="form.basic.slug"
                    ></b-form-input>
                </b-input-group>
                <div v-if="errors && errors.first('slug')" class="error_msg">
                  {{ errors.first('slug') }}
                </div>
            </CCol>
            <CCol class="col-4 mb-2">
              <label class="required">Measurement Ratio</label>
              <b-input-group>
                <b-form-input
                    label="Measurement Ratio"
                    type="text"
                    name="measurement_ratio"
                    v-model="form.basic.measurement_ratio"
                    placeholder="Measurement Ratio"
                    v-validate="'required|decimal:8'"
                ></b-form-input>
              </b-input-group>
              <div v-if="errors && errors.first('measurement_ratio')" class="error_msg">
              {{ errors.first('measurement_ratio') }}
              </div>
            </CCol>
            <CCol class="col-4 mb-2">
              <label>Select Add-ons</label>
              <div class="dropdown_wrapper">
                <v-select :multiple="true"  v-model="form.basic.selected_addons" :options="addons" name="product_addons" placeholder="Select Addons">
                </v-select>
              </div>
            </CCol>
            <CCol class="col-4 mt-4">
              <b-form-checkbox switch size="lg" v-model="form.basic.custom_color">Allow Custom Color</b-form-checkbox>
            </CCol>
            <CCol class="col-4 mt-4">
              <b-form-checkbox switch size="lg" v-model="form.basic.is_private">Private Product</b-form-checkbox>
            </CCol>
        </CRow>


      <div class="d-flex justify-content-between align-items-center mt-3">
        <div></div>
        <div class="d-flex gap-2">
          <b-button variant="primary" @click="GoToProductDesign(0)">Save and close</b-button>
          <b-button variant="primary" @click="GoToProductDesign(2)">Save and Stay</b-button>
        </div>
        <div>
          <b-button title="Next step" variant="primary" class="light" @click="GoToProductDesign(1)"><BIconArrowRight /></b-button>
        </div>
      </div>
    </div>
</template>
<script>
import "vue-select/dist/vue-select.css";

export default{
  props: ['step_completed', 'addons'],
    async created() {
        try{
            await this.$store.commit('set', ['showLoader', true]);

            if(this.$route.params.id)
              await this.$store.dispatch('getAllSkuIds', this.$route.params.id);
            else
              await this.$store.dispatch('getAllSkuIds');
            let skus = this.$store.getters.getSku;
            skus.forEach(element => {
                this.skus.push({
                  id: element.id,
                  label: element.sku_id,
                })
            });

            if(this.$route.params.id) {
                let res = await this.$store.dispatch('getBasic', this.$route.params.id);
                const response_data = res.data;
                if(response_data.data){
                this.form.basic.product_id = response_data.data.id;
                this.form.basic.selected_addons = response_data.data.addons
                      let sku = {
                    id: response_data.data.sku.id,
                    label:response_data.data.sku.sku_id
                }

                this.form.basic.sku = sku;
                this.form.basic.slug = response_data.data.url_slug;
                this.form.basic.measurement_ratio = response_data.data.measurement_ratio;
                this.selected_sku_factory_id = response_data.data.factory_id;
                let prod_type = {};
                if (response_data.data.product_type == 'personalized') {
                  prod_type = {label: 'Stock', code: response_data.data.product_type}
                } else {
                  prod_type = {label: this.capitalize(response_data.data.product_type), code: response_data.data.product_type}
                }
                this.form.basic.product_type = prod_type;
                this.form.basic.custom_color = (response_data.data.is_custom_color_allowed == 1) ? true : false;
                this.form.basic.is_private = (response_data.data.is_private === 1) ? true : false;
                this.previous_product_type = this.form.basic.product_type.code;
                await this.$store.commit('set', ['showLoader', false]);
                this.$emit('product-series', this.form.basic);
                this.$emit('change-product-type', this.form.basic.product_type);
                this.$emit('set-product-id', response_data.data.id);
                this.$emit('set-factory-id', response_data.data.factory_id);
                this.$emit('set-step-completed', response_data.data.step_completed);
                if (response_data.data.step_completed == 1) {
                  this.$emit('set-tab-index', 1, 'next');
                }
              }else{
                  this.$router.push('/products');
              }
            }
            else{
                this.is_default_design = true;
            }
            this.addBasicValidationRules()
            await this.$store.commit('set', ['showLoader', false]);
        }catch(err){
          console.log(err);
          const message = err.messaage ? err.messaage : 'Error in basic.vue created hook'
            this.showToast(message, 'DANGER');
        }
    },
    data() {
        return{
            form: {
              basic: {
                product_id:0,
                slug: '',
                measurement_ratio:0.0000,
                sku:{id:0,label:""},
                custom_color: true,
                product_type:{label:'Stock',code:'personalized'},
                is_private:false,
                selected_addons: []
              },
            },
          checked_index: -1,
          is_default_design: false,
          limit: [],
          skus: [],
          factory_skus:[],
          sku_ids: [],
          product_types:[{label:'Stock',code:'personalized'},{label:'Customized',code:'customized'}],
          basic_error_messages: {
            custom: {
              slug:{
                required:"Slug field is required"
              },
              sku:{
                required:"SKU field is required"
              },
              product_type: {
                required: 'Product type field is required'
              },
              measurement_ratio: {
                required: 'Measurement ratio field is required'
              }
            }
          },
          previous_product_type:'',
          selected_sku_factory_id:null

        }
    },
    computed:{
      is_float(value){
        return ((typeof value==='number')&&(value%1!==0));
      }
    },
    methods: {
      checkSKU(option){
        return !this.sku_ids.includes(option.id);
      },
      CheckDefault(event, index){

        this.is_default_design = event;
        if(event){
          this.limit.push(event)
          this.checked_index = index;
        }else{
          this.limit = [];
          this.checked_index = -1;
        }

      },
      getSkuLabel(sku_id){
        this.sku_ids.push(sku_id);
        let index = this.skus.findIndex(sku => sku.value == sku_id);
        return this.skus[index] ? this.skus[index].label : '';
      },
      async SetProductDetail() {
        // let first_model_factory_id = this.form.basic.models[0].sku.factory_id;
        // let model = this.form.basic.models[index].sku;
        let sku = this.form.basic.sku;
        if (sku) {
          this.form.basic.sku.id = sku.id;
          this.form.basic.sku.sku_id = sku.sku_id;
          this.$nextTick(async () => {
            await this.$validator.validate();
          })

        } else {
          this.form.basic.sku.id  = 0;
          this.form.basic.sku.sku_id = '';
        }
      },
      validateBasic(){
        let valid = true;
        let message = '';
        if(this.form.basic.sku.id < 0 && this.form.basic.sku.label === ""){
          valid = false;
          this.showToast('Select SKU', 'DANGER');
        } 
        if(!this.form.basic.slug){
          valid = false;
          this.showToast('Please enter a slug', 'DANGER');
        }
        if(!this.form.basic.measurement_ratio === 0){
          valid = false;
          this.showToast('Please enter a Measurement Ratio', 'DANGER');
        }  
        if(!this.form.basic.product_type) {
          valid = false;
          this.showToast('Select Product Type', 'DANGER');
        }
        return valid;
      },
      async GoToProductDesign(proceed){
        this.addBasicValidationRules()
        let valid = await this.$validator.validate();
        if(valid && this.validateBasic()) {
          try {
            let basicFormData = {};
            basicFormData.product_id = this.form.basic.product_id;
            basicFormData.url_slug = this.form.basic.slug;
            basicFormData.measurement_ratio = this.form.basic.measurement_ratio;
            basicFormData.product_type = this.form.basic.product_type;
            basicFormData.is_published = this.form.basic.published;
            basicFormData.is_private = this.form.basic.is_private;
            basicFormData.is_custom_color_allowed = this.form.basic.custom_color;
            basicFormData.sku = this.form.basic.sku
            basicFormData.addons = this.form.basic.selected_addons
            let confirm_text = `You have changed the product type. Your product will be un-published and
             You have to set the product designs again in next step.`;
            if((this.previous_product_type != this.form.basic.product_type.code) && this.step_completed > 1){
              await this.$confirm(confirm_text).then(async ()=>{
                this.submitForm(basicFormData, proceed)
                this.$emit('clear-style-designs');
              }).catch(e => {
                console.log(e)
              })
            }else{
              this.submitForm(basicFormData, proceed);
            }

          } catch (err) {
            this.showError(err);
          }

        } else {
          this.showToast("Please fill all required fields", "error");
        }
      },
      async submitForm(basicFormData, proceed){
        this.$store.commit('set', ['showLoader', true]);
        let response = await this.$store.dispatch('saveProductStep1', basicFormData);
        if(!response || (response.status != 201 && response.status != 200)) {
            return;
        }

        this.$store.commit('set', ['showLoader', false]);
        if (proceed==1) {

          this.$emit('form-basic', this.form.basic);
          this.$emit('change-product-type', this.form.basic.product_type);
          this.$emit('set-step-completed', response.data.data.step_completed);
          this.form.basic.product_id = response.data.data.id
          await this.$emit('set-product-id', response.data.data.id);
          await this.$emit('set-factory-id', this.selected_sku_factory_id);
          this.$emit('set-tab-index', 1, '');
        } else if(proceed == 2) {
          this.showToast('Product has been saved successfully','SUCCESS')
          this.$emit('product-series', this.form.basic);
          this.$emit('change-product-type', this.form.basic.product_type);
          this.$emit('set-step-completed', response.data.data.step_completed);
          this.form.basic.product_id = response.data.data.id
          this.$emit('set-product-id', response.data.data.id);
          this.$emit('set-factory-id', this.selected_sku_factory_id);
        }else{
          this.showToast('Product has been saved successfully','SUCCESS')
          this.$router.push('/products');
        }

      },
      capitalize(s){
        return s[0].toUpperCase() + s.slice(1);
     },
      addBasicValidationRules(){
        this.$validator.localize('en', this.basic_error_messages);
      }

    }
}
</script>
<style type="scss" scoped>
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
    .basci_switch{
        display: block;
    }
    input[type='file']{
        display: none;
    }
    .input-group .input-group-prepend, .input-group .input-group-prepend .input-group-text{
        background-color: #009FE3;
        background-color: #009FE3;
        border-color: #009FE3;
        color: #fff;
    }
    .deleteBtn{
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 14px;
    opacity: 1;
    color: #009FE3;
    font-weight: bold;
    padding: 10px 25px;
    font-size: 1rem;
  }
  .addBtn{
    background: #009FE3 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 14px;
    opacity: 1;
    font-weight: bold;
    padding: 10px 25px;
    font-size: 1rem;
    color: #FFFFFF;
  }
  .btngroup{
    padding: 10px;
    margin-bottom: 20px;
    background: #F5F5F5 0% 0% no-repeat padding-box;
  }
  label.required::after{
    content: "*";
    color: red;
  }
  .offset_row input, .offset input{
    width: 50px;
    height: 40px;
  }
  .offset_row input[placeholder], .offset input {
    text-align: center;
  }
  .switches{
    display: inline-block;
  }
  .c-switch-slider {
    background-color: #999999;
    border: 1px solid #999999;
  }
  .c-switch-primary .c-switch-input:checked + .c-switch-slider {
    background-color: #39f;
    border-color: #39f;
  }
  .file-select > .select-button {
    padding: 1rem;
    color: white;
    background-color: #2EA169;
    border-radius: .3rem;
    text-align: center;
    font-weight: bold;
  }
  .input-group-append{
    padding-left: 10px;
  }

  input[readonly]{
    background: #fff !important;
  }
  .position_offset{
    display: flex;
    flex-direction: column;
    flex-grow: inherit;
    margin-bottom: 1rem;
  }
  .form-group{
    margin: 0;
  }
  .first_offset{
    padding-left: 15px;
  }
  .input-group-append > span{
    cursor: pointer;
  }
  .dropdown_wrapper{
    display: flex;
  }


  .file_upload{
    position: relative;
    overflow: hidden;
    display: inline-block;
    cursor: pointer;
  }
    .occlusion_map, .normal_map, .model_3d{
        width: 100%;
        border: 1px solid;
        background-color: #FFFFFF;
        border-color: #d8dbe0;
        border-radius: 0.25rem;
        padding: 0.375rem 0.75rem;
    }
    .occlusion_map_input, .normal_map_input, .model_3d_input{
        display: none;
    }

    .add-product-holder .btn-primary{
        background: #009FE3;
        border-color: #009FE3;
        font-size: 20px;
        padding: 0.5rem 2rem;
    }
    .btn-primary.light{
      background: #c8e4f3 !important;
      border-color: #c8e4f3 !important;
      color: #009FE3 !important;
    }
    .basic-category-row .dropdown_wrapper div.v-select{
      height: auto;
    }

    .product-details{
      border-radius: 10px;
      box-shadow: 0 0 13px 0 rgba(0,0,0,0.13);
      position: relative;
    }

    .remove-icon{
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 2em;
      height: 30px;
      width: 30px;
      background: #C80000;
      color: #fff;
      border-radius: 99px;
      position: absolute;
      right: -10px;
      top: -10px;
      cursor: pointer;
      transition: 0.2s all ease;
      z-index: 30;
    }

    .remove-icon:hover{
      background: #ff0000;
    }
</style>
